/**
 * Footer Marquee – Web Component
 * Handles pause-on-hover and respects prefers-reduced-motion.
 */
class FooterMarquee extends HTMLElement {
  connectedCallback() {
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.resume.bind(this));
    }
  }

  pause() {
    this.setAttribute('data-paused', 'true');
  }

  resume() {
    this.removeAttribute('data-paused');
  }

  disconnectedCallback() {
    if (this.pauseOnHover) {
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.resume);
    }
  }
}

if (!customElements.get('footer-marquee')) {
  customElements.define('footer-marquee', FooterMarquee);
}
